import type {
  FindReplaceRule,
  IImageReplaceRule,
  IImageReplaceWithVariableRule,
  ITextReplaceRule,
} from '@carboncopyco/types';
import { IFindAndReplaceRuleType } from '@carboncopyco/types';
import { compareUrls } from './url';

export const isReplaceTextRule = (
  rule: FindReplaceRule
): rule is ITextReplaceRule =>
  rule.type === IFindAndReplaceRuleType.replaceText;

export const isReplaceImageRule = (
  rule: FindReplaceRule
): rule is IImageReplaceRule =>
  rule.type === IFindAndReplaceRuleType.replaceImage;

export const isReplaceImageWithVariableRule = (
  rule: FindReplaceRule
): rule is IImageReplaceWithVariableRule =>
  rule.type === IFindAndReplaceRuleType.replaceImageWithVariable;

export const findImageReplaceRuleByUrl = (
  params: { url: string; ignoredQueryParams?: string[] },
  rules: FindReplaceRule[]
) => {
  const { url, ignoredQueryParams } = params;
  if (!url || url?.startsWith('data:image/')) {
    return;
  }

  return rules
    ?.filter(
      (rule): rule is IImageReplaceRule | IImageReplaceWithVariableRule =>
        isReplaceImageRule(rule) || isReplaceImageWithVariableRule(rule)
    )
    .find(({ sourceUrl }) =>
      compareUrls(sourceUrl, url, { ignoredQueryParams })
    ) as IImageReplaceRule;
};
